<div class="card card-w-title">
  <div class="ui-g form-group">
    <div class="ui-g-10">
      <span class="md-inputfield">
        <input type="text" class="full-width" [(ngModel)]="politica.nome" name="nome" pInputText>
        <label>Nome</label>
      </span>
    </div>
    <div class="ui-g-2">
      <span class="md-inputfield">
        <input type="number"  [(ngModel)]="politica.versao" name="versao" pInputText>
        <label>Versão</label>
      </span>
    </div>

    <div class="ui-g-12 container-texto">
      <div class="editor">
        <ngx-editor-menu 
          [editor]="editor" 
          [toolbar]="toolbar">
        </ngx-editor-menu>
        <ngx-editor 
          [editor]="editor"
          [outputFormat]="'html'"
          [(ngModel)]="politica.texto">
        </ngx-editor>
      </div>
    </div>
  </div>
</div>
